import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  private loadUserNotificationSource = new BehaviorSubject('');
  onLoadUserNotification = this.loadUserNotificationSource.asObservable();
  loadUserNotification(caller: string) {
    this.loadUserNotificationSource.next(caller);
  }

  private loadOrderOverviewSource = new BehaviorSubject('');
  onLoadOrderOverview = this.loadOrderOverviewSource.asObservable();
  loadOrderOverview(caller: string) {
    this.loadOrderOverviewSource.next(caller);
  }

  private loadDMOverviewSource = new BehaviorSubject('');
  onLoadDMOverview = this.loadDMOverviewSource.asObservable();
  loadDMOverview(caller: string) {
    this.loadDMOverviewSource.next(caller);
  }

  private loadStockOverviewSource = new BehaviorSubject('');
  onLoadStockOverview = this.loadStockOverviewSource.asObservable();
  loadStockOverview(caller: string) {
    this.loadStockOverviewSource.next(caller);
  }

  private loadShipCrewSource = new BehaviorSubject('');
  onLoadShipCrew = this.loadShipCrewSource.asObservable();
  loadShipCrew(caller: string) {
    this.loadShipCrewSource.next(caller);
  }

  private loadIFSSurveySource = new BehaviorSubject('');
  onLoadIFSSurvey = this.loadIFSSurveySource.asObservable();
  loadIFSSurvey(caller: string) {
    this.loadIFSSurveySource.next(caller);
  }

  private loadShipAuditOverviewSource = new BehaviorSubject('');
  onLoadShipAuditOverview = this.loadShipAuditOverviewSource.asObservable();
  loadShipAuditOverview(caller: string) {
    this.loadShipAuditOverviewSource.next(caller);
  }
}
